<template>
   <div>
      <router-link
          :to="{ name: 'contentList', params: { listName: 'faq' } }"
          class="mr-3"
      >
         <span class="icon-info"></span>
      </router-link>

   <dropdown-nav key="loginDropdown" ref="loginDropdown" arrow="right" toggler-class="header-nav-item small">
        <template slot="label">
            <span class="icon-user mr-2 "></span> SIGN IN
        </template>
        <div style="padding: 20px;width: 300px;">
            <b-form @submit="onLogin">
                <b-form-group>
                    <b-form-input
                            id="email"
                            v-model="loginForm.email"
                            type="email"
                            :state="apiError ? false : null"
                            required
                            placeholder="E-MAIL ADRESS"
                            class="secondary"
                            autocomplete="username">
                    </b-form-input>
                </b-form-group>
                <b-form-group>
                    <b-form-input
                            id="password"
                            v-model="loginForm.password"
                            type="password"
                            class="secondary"
                            required
                            :state="apiError ? false : null"
                            placeholder="PASSWORD"
                            autocomplete="current-password">
                    </b-form-input>
                </b-form-group>
                <b-form-group>
                    <pb-btn :busy="loggingIn" block variant="primary" type="submit"
                            icon="fa-arrow-right fa-sm">
                        SIGN IN
                    </pb-btn>
                </b-form-group>
            </b-form>
            <b-alert class="text-left" v-if="apiError" variant="danger" show>{{apiError}}</b-alert>
            <b-link class="d-block text-center" v-b-modal.passwordRecoveryModal
                    @click.stop="$refs.passwordRecoveryModal.resetData()">
                PASSWORD RECOVERY
            </b-link>
            <b-link class="d-block text-center my-2" v-b-modal.registrationModal
                    @click.stop="$refs.registrationModal.resetData()">
                DON'T HAVE AN ACCOUNT?
            </b-link>
        </div>
        <registration-modal
                ref="registrationModal"
                id="registrationModal">
        </registration-modal>
        <password-recovery-modal
                ref="passwordRecoveryModal"
                id="passwordRecoveryModal">
        </password-recovery-modal>
    </dropdown-nav>
   </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import DropdownNav from "../../../../components/DropdownNav";
    import RegistrationModal from "../../../pages/RegistrationModal";
    import PasswordRecovery from "../../../pages/PasswordRecovery";

    export default {
        name: 'login-bar',
        components: {
            'dropdown-nav': DropdownNav,
            'registration-modal': RegistrationModal,
            'password-recovery-modal': PasswordRecovery
        },
        data() {
            return {
                loggingIn: false,
                loginForm: {
                    email: null,
                    password: null
                }
            };
        },
        methods: {
            ...mapActions('account', ['login']),
            ...mapActions('cart', ['fetchCart']),
            ...mapActions('favorites', ['fetchFavorites']),
            ...mapActions('sample', ['fetchSampleList']),
            onLogin: function (evt) {
                evt.preventDefault();

                if (this.loginForm.email && this.loginForm.password) {
                    this.loggingIn = true;
                    this.login({username: this.loginForm.email, password: this.loginForm.password}).then(() => {

                      if(this.$cookies.isKey('initialUrl')) {
                        let initialUrl = this.$cookies.get('initialUrl');
                        this.$cookies.remove('initialUrl');
                        window.location.href = initialUrl;
                      } else {
                        this.$router.push('/');
                      }

                        if (this.$refs.loginDropdown) {
                            this.$refs.loginDropdown.forceHide();
                        }
                        this.fetchCart();
                        this.fetchSampleList();
                        this.fetchFavorites();

                        if (this.user.externalData && window.LiveChatWidget) {
                            window.LiveChatWidget.call('set_customer_name', this.user.firstName + ' ' + this.user.lastName);
                            window.LiveChatWidget.call('set_customer_email', this.user.email);
                        }
                    }).finally(() => this.loggingIn = false);
                }
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
        },
        computed: {
            ...mapState('account', ['apiError', 'user']),
        }
    }
</script>
